import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { getListPartner } from '../../../services/api/3dApi'
import { getListProductionStage, createProductProcess } from '../../../services/api/apiSku'
import { Row, Col, Input, Switch, Select, Button, message, Spin } from 'antd'
import FilterInput from './filter/FilterInput'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

const { TextArea } = Input

const CreateProductionProcess = () => {
    const [loading, setLoading] = useState(false)
    const [stageOptions, setStageOptions] = useState([])
    const [partners, setPartners] = useState([])
    const [stages, setStages] = useState([
        {
            index: 1,
            stage: ''
        }
    ])
    const [requests, setRequest] = useState({})

    const history = useHistory()

    useEffect(() => {
        _fetchListPartner()
        _fetchListStages()
    }, [])

    const _fetchListPartner = async () => {
        try {
            const { data, success, message: mess } = await getListPartner()
            if (!success) return message.error(mess)
            const { partners } = Object.assign({}, data)

            const listPartners = partners.map(i => ({
                label: i.name,
                value: i._id,
            }))

            setPartners(listPartners)

        } catch (error) {
            message.error(error.message)
        }
    }

    const _fetchListStages = async () => {
        try {
            const { data: res } = await getListProductionStage({ limit: 100 })
            const { data, success, message: mess } = Object.assign({}, res)
            if (!success) return message.error(mess)

            const listStages = data.stages.map(i => ({
                label: `${i.name} - ${i.partner.name}`,
                value: i._id
            }))
            setStageOptions(listStages)

        } catch (error) {
            message.error(error.message)
        }
    }

    const handleChangeRequest = (field, value) => {
        setRequest({
            ...requests,
            [field]: value
        })
    }

    const handleAddProcess = () => {
        const stageEnd = stages[stages.length - 1].stage
        if (!stageEnd) return

        const newStages = [
            ...stages,
            {
                index: stages.length + 1,
                stage: ''
            }
        ]
        setStages(newStages)
    }

    const handleDeleteProcess = (index) => {
        const newStages = stages.map(i => {
            if (i.index !== index) {
                return {
                    ...i,
                    index: i.index <= index ? i.index : i.index - 1
                }
            }
        }).filter(Boolean)

        setStages(newStages)
    }

    const handleChangeStage = (index, value) => {
        const newStages = stages.map(i => {
            if (i.index === index) {
                return {
                    ...i,
                    stage: value
                }
            }
            return i
        })
        setStages(newStages)
    }

    const handleDrop = (droppedItem) => {
        if (!droppedItem.destination) return
        const currentIndex = droppedItem.destination.index + 1
        const preIndex = droppedItem.source.index + 1
        var stagesList = [...stages]
        const [reorderedItem] = stagesList.splice(droppedItem.source.index, 1)
        stagesList.splice(droppedItem.destination.index, 0, reorderedItem)

        const newStages = stagesList.map(i => {
            if (preIndex < currentIndex) {
                if (i.index === preIndex) {
                    return {
                        ...i,
                        index: currentIndex
                    }
                }

                if (i.index <= currentIndex && i.index > preIndex) {
                    return {
                        ...i,
                        index: i.index - 1
                    }
                }

                return i
            } else {
                if (i.index === preIndex) {
                    return {
                        ...i,
                        index: currentIndex
                    }
                }

                if (i.index <= preIndex && i.index >= currentIndex) {
                    return {
                        ...i,
                        index: i.index + 1
                    }
                }

                return i
            }
        })

        setStages(newStages)
    }

    const getItemStyle = (isDragging, draggableStyle) => ({
        position: 'relative',
        ...draggableStyle,
    })

    const handleSave = async () => {
        setLoading(true)
        try {
            const payload = {
                ...requests,
                stages: stages.map(i => i.stage).filter(Boolean),
                name: requests.name ? requests.name.trim() : '',
                note: requests.note ? requests.note.trim() : '',
            }
            if (!payload.name) return message.error("Bạn cần nhập tên quy trình.")
            if (!payload.partner) return message.error("Bạn cần chọn đối tác sản xuất.")
            if (!!payload.stages && payload.stages.length === 0) return message.error("Cần có ít nhất 1 công đoạn sản xuất.")

            const { data: res } = await createProductProcess(payload)
            const { data, success, message: mess } = Object.assign({}, res)

            if (!success) return message.error(mess)

            message.success('Thêm mới quy trình thành công!')
            const { _id } = Object.assign({}, data)
            history.push(`/production-process/${_id}`)

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Spin tip="Loading..." spinning={loading}>
            <div className='CreateProductionProcess'>
                <div className="ReturnPage">
                    <Link to={'/production-process'} className="txt-16">
                        <i className="fa fa-chevron-left mr-1" /> Cấu hình quy trình sản xuất
                    </Link>
                </div>
                <div className='FileDetailPage'>
                    <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                        <h1 className="PageTitle font-weight-bold mb-0">Thêm mới quy trình sản xuất</h1>
                        <div className="RightTop">
                            <div className='Actions mb-2'>
                                <Link to={'/production-process'}>
                                    <button
                                        className='btn btn-secondary mx-1 px-3'
                                        style={{ background: '#C4C4C4' }}
                                    >
                                        Hủy
                                    </button>
                                </Link>
                                <button
                                    className='btn btn-primary mx-1 px-3'
                                    style={{ background: '#4A80F7' }}
                                    onClick={handleSave}
                                >
                                    Lưu
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="SectionInner card px-2 py-2 mt-3" style={{ minHeight: '70vh' }}>
                        <Row className='px-3 mb-3'>
                            <Col span={12}>
                                <label htmlFor="" className='font-weight-bold mb-1 h6'>Tên quy trình <span className='text-danger'>*</span></label>
                                <FilterInput
                                    field='name'
                                    onChange={handleChangeRequest}
                                    style={{ width: '100%' }}
                                    placeholder="Nhập tên quy trình"
                                />
                            </Col>
                        </Row>
                        <Row className='px-3 mb-3'>
                            <Col span={12}>
                                <label htmlFor="" className='font-weight-bold mb-1 h6'>Đối tác sản xuất <span className='text-danger'>*</span></label>
                                <FilterInput
                                    options={partners}
                                    placeholder="Chọn đối tác sản xuất"
                                    onChange={handleChangeRequest}
                                    field='partner'
                                    type='select'
                                />
                            </Col>
                        </Row>
                        <Row className='px-3 mb-3'>
                            <Col span={12}>
                                <label htmlFor="" className='font-weight-bold mb-1 h6'>Trạng thái</label>
                                <Switch
                                    className='ml-5'
                                    onChange={checked => handleChangeRequest('is_active', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='px-3 mb-3'>
                            <Col span={12}>
                                <label htmlFor="" className='font-weight-bold mb-1 h6'>Cộng đoạn sản xuất <span className='text-danger'>*</span></label>
                                <Row>
                                    <Col span={5}></Col>
                                    <Col span={19}>
                                        <DragDropContext onDragEnd={handleDrop}>
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {stages.map((item, index) => (
                                                            <Draggable key={`${item.stage}_${index}`} draggableId={`${item.stage}_${index}`} index={index} className="position-relative">
                                                                {(provided, snapshot) => (
                                                                    <div
                                                                        className="item-process d-flex align-items-center justify-content-between mb-2"
                                                                        ref={provided.innerRef}
                                                                        {...provided.dragHandleProps}
                                                                        {...provided.draggableProps}
                                                                        style={getItemStyle(
                                                                            snapshot.isDragging,
                                                                            provided.draggableProps.style
                                                                        )}
                                                                    >
                                                                        <span>Công đoạn {item.index}</span>
                                                                        <Select
                                                                            placeholder="Chọn công đoạn"
                                                                            value={item.stage || []}
                                                                            style={{ minWidth: '80%' }}
                                                                            onChange={value => handleChangeStage(item.index, value)}
                                                                        >
                                                                            {
                                                                                stageOptions.map(i => (
                                                                                    <Select.Option key={i.value} disabled={stages.some(o => o.stage === i.value)}>{i.label}</Select.Option>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                        {item.index > 1 && <i className="icon-bin text-danger cursor-pointer ml-2" style={{ position: 'absolute', top: 8, right: -32 }}
                                                                            onClick={() => handleDeleteProcess(item.index)}
                                                                        />}
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                        {stages.length < stageOptions.length && <Button className='float-right font-weight-bold' onClick={handleAddProcess}>
                                            Thêm công đoạn
                                        </Button>}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='px-3 mt-3'>
                            <Col span={12}>
                                <label htmlFor="" className='font-weight-bold mb-1 h6'>Ghi chú</label>
                                <TextArea
                                    rows={4}
                                    onChange={e => handleChangeRequest('note', e.target.value)}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Spin>
    )
}

export default CreateProductionProcess